/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateLeadSOffenderRecordRequest
 */
export interface UpdateLeadSOffenderRecordRequest {
    [key: string]: any | any;
    /**
     * 
     */
    is_dismissed: boolean;
    /**
     * Deprecated - will be ignored, use lead_id from existing record
     */
    lead_id?: string;
}

/**
 * Check if a given object implements the UpdateLeadSOffenderRecordRequest interface.
 */
export function instanceOfUpdateLeadSOffenderRecordRequest(value: object): value is UpdateLeadSOffenderRecordRequest {
    if (!('is_dismissed' in value) || value['is_dismissed'] === undefined) return false;
    return true;
}

export function UpdateLeadSOffenderRecordRequestFromJSON(json: any): UpdateLeadSOffenderRecordRequest {
    return UpdateLeadSOffenderRecordRequestFromJSONTyped(json, false);
}

export function UpdateLeadSOffenderRecordRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateLeadSOffenderRecordRequest {
    if (json == null) {
        return json;
    }
    return {
        
            ...json,
        'is_dismissed': json['is_dismissed'],
        'lead_id': json['lead_id'] == null ? undefined : json['lead_id'],
    };
}

export function UpdateLeadSOffenderRecordRequestToJSON(json: any): UpdateLeadSOffenderRecordRequest {
    return UpdateLeadSOffenderRecordRequestToJSONTyped(json, false);
}

export function UpdateLeadSOffenderRecordRequestToJSONTyped(value?: UpdateLeadSOffenderRecordRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
            ...value,
        'is_dismissed': value['is_dismissed'],
        'lead_id': value['lead_id'],
    };
}

